<!-- Content Area -->
<div class="p-4 md:p-8">
    <div class="flex justify-between items-center mb-6 gap-4">
        <h1 class="text-xl lg:text-3xl font-bold text-gray-900">User List</h1>
        <button (click)="openAddModal()"
            class="bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 text-base lg:text-sm font-semibold rounded-lg transition flex items-center gap-2">
            <span>+</span>
            <span>Add User</span>
        </button>
    </div>

    <!-- Table -->
    <div class="bg-white rounded-lg shadow-sm mb-6 overflow-x-auto">
        <table class="w-full min-w-[800px]">
            <thead>
                <tr class="border-b border-gray-200">
                    <th class="text-left py-4 px-6 text-sm font-semibold text-gray-600 uppercase tracking-wider">
                        No
                    </th>
                    <th class="text-left py-4 px-6 text-sm font-semibold text-gray-600 uppercase tracking-wider">
                        Name
                    </th>
                    <th class="text-left py-4 px-6 text-sm font-semibold text-gray-600 uppercase tracking-wider">
                        Username
                    </th>
                    <th class="text-left py-4 px-6 text-sm font-semibold text-gray-600 uppercase tracking-wider">
                        Email
                    </th>
                    <th class="text-left py-4 px-6 text-sm font-semibold text-gray-600 uppercase tracking-wider">
                        Role
                    </th>
                    <th class="text-left py-4 px-6 text-sm font-semibold text-gray-600 uppercase tracking-wider">
                        Status
                    </th>
                    <th class="text-center py-4 px-6 text-sm font-semibold text-gray-600 uppercase tracking-wider">
                        Action
                    </th>
                </tr>
            </thead>
            <tbody class="divide-y divide-gray-100">
                <tr *ngFor="let user of User; let i = index" class="hover:bg-gray-50 transition-colors">
                    <td class="py-4 px-6 text-sm text-gray-900">
                        {{ i + 1 }}
                    </td>
                    <td class="py-4 px-6 text-sm text-gray-900">
                        {{ user.name }}
                    </td>
                    <td class="py-4 px-6 text-sm text-gray-900">
                        {{ user.username }}
                    </td>
                    <td class="py-4 px-6 text-sm text-gray-600">
                        {{ user.email }}
                    </td>
                    <td class="py-4 px-6 text-sm text-gray-600">
                        {{ user.roles[0]?.name || "-" }}
                    </td>
                    <td class="py-4 px-6 text-sm">
                        <span class="px-2 py-1 rounded-full text-xs font-medium" [ngClass]="{
                                'bg-green-100 text-green-800':
                                    user.status === 'active',
                                'bg-red-100 text-red-800':
                                    user.status === 'inactive',
                                'bg-yellow-100 text-yellow-800':
                                    user.status === 'pending'
                            }">
                            {{ user.status | titlecase }}
                        </span>
                    </td>
                    <td class="py-4 px-6">
                        <div class="flex items-center justify-center gap-0">
                            <button (click)="openEditModal(user.id)"
                                class="text-gray-600 hover:text-gray-900 transition-colors border border-[#D5D5D5] py-2 px-4 rounded-l-lg hover:bg-gray-50">
                                <img src="assets/visidea/icon/pencil-write.png" class="w-[16px] h-[16px]"
                                    alt="Edit" />
                            </button>
                            <button *ngIf="hasLoketRole(user)" (click)="openGateModal(user)"
                                class="text-gray-600 hover:text-gray-900 transition-colors border border-[#D5D5D5] py-2 px-4 hover:bg-gray-50"
                                title="Set Gate">
                                <img src="assets/visidea/icon/icon-gate.png" class="w-[16px] h-[16px]"
                                    alt="Gate" />
                            </button>
                            <button (click)="deleteUser(user.id, user.name)"
                                class="text-red-500 hover:text-red-700 transition-colors border border-[#D5D5D5] py-2 px-4 rounded-r-lg hover:bg-red-50">
                                <img src="assets/visidea/icon/bin.png" class="w-[16px] h-[16px]"
                                    alt="Delete" />
                            </button>
                        </div>
                    </td>
                </tr>

                <!-- Empty State -->
                <tr *ngIf="User.length === 0">
                    <td colspan="6" class="py-8 text-center text-gray-500">
                        Tidak ada data user
                    </td>
                </tr>
            </tbody>
        </table>

        <!-- Pagination -->
        <div
            class="flex flex-col md:flex-row items-center justify-between px-6 py-4 border-t border-gray-200 gap-4 bg-white rounded-b-lg">

            <!-- Info Text -->
            <div class="text-center md:text-left w-full md:w-auto order-1">
                <span class="text-sm text-gray-600">
                    Showing {{ startIndex }} to {{ endIndex }} of {{ pagination.total }} entries
                </span>
            </div>

            <!-- Pagination Controls -->
            <div class="flex items-center gap-1 order-2 w-full md:w-auto justify-center md:justify-end">
                <!-- Previous Arrow -->
                <button (click)="previousPage()" [disabled]="pagination.current_page === 1"
                    class="w-8 h-8 flex items-center justify-center rounded-lg text-gray-500 hover:bg-gray-100 disabled:opacity-50 disabled:hover:bg-transparent transition-colors">
                    <img src="assets/visidea/icon/left.png" class="w-[10px] h-[10px]" alt="Previous" />
                </button>

                <!-- Page Numbers -->
                <ng-container *ngFor="let page of visiblePages">
                    <button *ngIf="page !== '...'" (click)="goToPage(page)"
                        class="w-8 h-8 flex items-center justify-center rounded-lg text-sm font-medium transition-colors"
                        [ngClass]="{
                            'bg-blue-500 text-white': page === pagination.current_page,
                            'text-gray-600 hover:bg-gray-100': page !== pagination.current_page
                        }">
                        {{ page }}
                    </button>
                    <span *ngIf="page === '...'" class="w-8 h-8 flex items-center justify-center text-gray-400">
                        ...
                    </span>
                </ng-container>

                <!-- Next Arrow -->
                <button (click)="nextPage()" [disabled]="pagination.current_page === pagination.total_page"
                    class="w-8 h-8 flex items-center justify-center rounded-lg text-gray-500 hover:bg-gray-100 disabled:opacity-50 disabled:hover:bg-transparent transition-colors">
                    <img src="assets/visidea/icon/right.png" class="w-[10px] h-[10px]" alt="Next" />
                </button>
            </div>

            <!-- Empty div for layout balance on desktop (Right side) if needed, but centered layout doesn't require it if we use simple flex-col -->
        </div>
    </div>
</div>

<!-- Modal Add/Edit User -->
<div *ngIf="isModalOpen" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
    <div class="bg-white rounded-lg shadow-xl max-w-md w-full p-6 animate-fadeIn" (click)="$event.stopPropagation()">
        <div class="flex justify-between items-center mb-6">
            <h2 class="text-2xl font-bold text-gray-900">
                {{ isEditMode ? "Edit User" : "Add New User" }}
            </h2>
            <button (click)="closeModal()" class="text-gray-400 hover:text-gray-600 text-2xl">
                &times;
            </button>
        </div>

        <form (ngSubmit)="onSubmit()" #userFormElement="ngForm" class="overflow-y-auto max-h-[80vh] scrollbar-hide">
            <!-- Name -->
            <div class="mb-4">
                <label class="block text-sm font-medium text-gray-700 mb-2">
                    Name <span class="text-red-500">*</span>
                </label>
                <input type="text" [(ngModel)]="userForm.name" name="name" required
                    class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter name" />
            </div>

            <!-- Username -->
            <div class="mb-4">
                <label class="block text-sm font-medium text-gray-700 mb-2">
                    Username <span class="text-red-500">*</span>
                </label>
                <input type="text" [(ngModel)]="userForm.username" name="username" required
                    class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter username" />
            </div>

            <!-- Email -->
            <div class="mb-4">
                <label class="block text-sm font-medium text-gray-700 mb-2">
                    Email <span class="text-red-500">*</span>
                </label>
                <input type="email" [(ngModel)]="userForm.email" name="email" required
                    class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter email" />
            </div>

            <!-- Password -->
            <div class="mb-4">
                <label class="block text-sm font-medium text-gray-700 mb-2">
                    Password
                    <span class="text-red-500" *ngIf="!isEditMode">*</span>
                    <span class="text-gray-500 text-xs" *ngIf="isEditMode">(Leave empty to keep current)</span>
                </label>
                <input type="password" [(ngModel)]="userForm.password" name="password" [required]="!isEditMode"
                    class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter password" />
            </div>

            <!-- Role -->
            <div class="mb-4">
                <label class="block text-sm font-medium text-gray-700 mb-2">
                    Role
                </label>
                <select [(ngModel)]="userForm.role_id" name="role_id"
                    class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500">
                    <option [value]="null">Select Role</option>
                    <option *ngFor="let role of roles" [value]="role.id">
                        {{ role.name }}
                    </option>
                </select>
            </div>

            <!-- Status -->
            <div class="mb-6">
                <label class="block text-sm font-medium text-gray-700 mb-2">
                    Status <span class="text-red-500">*</span>
                </label>
                <select [(ngModel)]="userForm.status" name="status" required
                    class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500">
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                    <option value="pending">Pending</option>
                </select>
            </div>

            <!-- Buttons -->
            <div class="flex gap-3">
                <button type="button" (click)="closeModal()" [disabled]="isSubmitting"
                    class="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition disabled:opacity-50">
                    Cancel
                </button>
                <button type="submit" [disabled]="isSubmitting"
                    class="flex-1 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition disabled:opacity-50 disabled:cursor-not-allowed">
                    <span *ngIf="!isSubmitting">
                        {{ isEditMode ? "Update" : "Create" }}
                    </span>
                    <span *ngIf="isSubmitting"> Processing... </span>
                </button>
            </div>
        </form>
    </div>
</div>

<!-- Modal Assign Gate -->
<div *ngIf="isGateModalOpen" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
    (click)="closeGateModal()">
    <div class="bg-white rounded-lg shadow-xl max-w-2xl w-full p-6 animate-fadeIn max-h-[90vh] overflow-y-auto"
        (click)="$event.stopPropagation()">
        <div class="flex justify-between items-center mb-6">
            <div>
                <h2 class="text-2xl font-bold text-gray-900">Assign Gates</h2>
                <p class="text-sm text-gray-600 mt-1" *ngIf="selectedUserForGate">
                    User:
                    <span class="font-semibold">{{
                        selectedUserForGate.name
                        }}</span>
                </p>
            </div>
            <button (click)="closeGateModal()" class="text-gray-400 hover:text-gray-600 text-2xl">
                &times;
            </button>
        </div>

        <!-- Gate List with Checkboxes -->
        <div class="mb-6">
            <label class="block text-sm font-medium text-gray-700 mb-3">
                Select Gates
                <span class="text-gray-500">({{ selectedGateIds.length }} selected)</span>
            </label>

            <div class="space-y-2 max-h-96 overflow-y-auto border border-gray-200 rounded-lg p-4">
                <!-- Empty State -->
                <div *ngIf="gates.length === 0" class="text-center py-8 text-gray-500">
                    Tidak ada data gate
                </div>

                <!-- Gate Items -->
                <label *ngFor="let gate of gates"
                    class="flex items-center p-3 hover:bg-gray-50 rounded-lg cursor-pointer transition-colors border border-gray-200"
                    [class.bg-blue-50]="isGateSelected(gate.id)" [class.border-blue-300]="isGateSelected(gate.id)">
                    <input type="checkbox" [checked]="isGateSelected(gate.id)" (change)="toggleGateSelection(gate.id)"
                        class="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 focus:ring-2" />
                    <div class="ml-3 flex-1">
                        <div class="flex items-center gap-2">
                            <span class="text-sm font-medium text-gray-900">
                                {{ gate.name }}
                            </span>
                            <span class="text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded">
                                {{ gate.code }}
                            </span>
                            <span class="text-xs px-2 py-1 rounded" [class.bg-green-100]="gate.type === 'entry'"
                                [class.text-green-700]="gate.type === 'entry'" [class.bg-red-100]="gate.type === 'exit'"
                                [class.text-red-700]="gate.type === 'exit'" [class.bg-blue-100]="gate.type === 'both'"
                                [class.text-blue-700]="gate.type === 'both'">
                                {{ gate.type }}
                            </span>
                        </div>
                        <p class="text-xs text-gray-500 mt-1">
                            Status:
                            <span [class.text-green-600]="
                                    gate.status === 'active'
                                " [class.text-red-600]="
                                    gate.status === 'inactive'
                                ">
                                {{ gate.status }}
                            </span>
                        </p>
                    </div>
                </label>
            </div>
        </div>

        <!-- Current Assigned Gates Info -->
        <div class="mb-6" *ngIf="
                selectedUserForGate?.gates &&
                selectedUserForGate.gates.length > 0
            ">
            <div class="bg-blue-50 border border-blue-200 rounded-lg p-4">
                <p class="text-sm font-medium text-blue-900 mb-2">
                    Currently Assigned Gates:
                </p>
                <div class="flex flex-wrap gap-2">
                    <span *ngFor="let gate of selectedUserForGate.gates"
                        class="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                        {{ gate.name }} ({{ gate.code }})
                    </span>
                </div>
            </div>
        </div>

        <!-- Buttons -->
        <div class="flex gap-3">
            <button type="button" (click)="closeGateModal()" [disabled]="isAssigningGates"
                class="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition disabled:opacity-50">
                Cancel
            </button>
            <button type="button" (click)="assignGates()" [disabled]="isAssigningGates"
                class="flex-1 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition disabled:opacity-50 disabled:cursor-not-allowed">
                <span *ngIf="!isAssigningGates">
                    Assign Gates ({{ selectedGateIds.length }})
                </span>
                <span *ngIf="isAssigningGates"> Processing... </span>
            </button>
        </div>
    </div>
</div>
